import { useMemo, useState } from "react";
import { UtensilsCrossed } from "lucide-react";
import { pick } from "@/lib/format";
import { imgSrc } from "@/lib/media";
import { Change } from "./SummaryCards";

const SORTS = { views: (i) => i.views, time: (i) => i.avg_view_s, engagement: (i) => i.open_rate ?? -1 };

export function ItemsTable({ items, t, lang, catName }) {
  const [sort, setSort] = useState("views");
  const rows = useMemo(() => [...items].sort((a, b) => SORTS[sort](b) - SORTS[sort](a)).slice(0, 25), [items, sort]);
  return (
    <div className="space-y-3 rounded-2xl border bg-card p-4" data-testid="analytics-items-table">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="font-bold">{t("an.popular")}</h3>
        <div className="flex gap-1 rounded-full border bg-secondary/30 p-1">
          {Object.keys(SORTS).map((k) => (
            <button key={k} type="button" onClick={() => setSort(k)} aria-pressed={sort === k} data-testid={`an-sort-${k}`}
              className={`rounded-full px-3 py-1 text-xs font-semibold ${sort === k ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>{t(`an.sort.${k}`)}</button>
          ))}
        </div>
      </div>
      <p className="text-[11px] text-muted-foreground">{t("an.viewsNote")}</p>
      {!rows.length ? <p className="py-6 text-center text-sm text-muted-foreground">{t("an.noData")}</p> : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] text-sm">
            <thead className="text-xs text-muted-foreground">
              <tr className="border-b text-start">
                {["#", "an.dish", "an.category", "an.views", "an.uniqueSessions", "an.avgView", "an.openRate", "an.change"].map((h) => <th key={h} className="px-2 py-2 text-start font-medium">{h === "#" ? "#" : t(h)}</th>)}
              </tr>
            </thead>
            <tbody>
              {rows.map((i, n) => (
                <tr key={i.id} className="border-b last:border-0" data-testid={`an-item-row-${i.id}`}>
                  <td className="px-2 py-2 tabular-nums text-muted-foreground">{n + 1}</td>
                  <td className="px-2 py-2">
                    <div className="flex items-center gap-2">
                      <span className="grid h-9 w-9 shrink-0 place-items-center overflow-hidden rounded-lg bg-secondary">
                        {i.image_url ? <img src={imgSrc(i.image_url, "sm")} alt="" loading="lazy" className="h-full w-full object-cover" /> : <UtensilsCrossed className="h-4 w-4 text-muted-foreground" />}
                      </span>
                      <span className="font-semibold">{pick(i, "title", lang).text}</span>
                    </div>
                  </td>
                  <td className="px-2 py-2 text-muted-foreground">{catName(i.category_id)}</td>
                  <td className="px-2 py-2 font-bold tabular-nums">{i.views}</td>
                  <td className="px-2 py-2 tabular-nums">{i.sessions}</td>
                  <td className="px-2 py-2 tabular-nums">{t("an.seconds", { n: i.avg_view_s })}</td>
                  <td className="px-2 py-2 tabular-nums">{i.open_rate === null ? "–" : `${i.open_rate}%`}</td>
                  <td className="px-2 py-2"><Change value={i.change_pct} t={t} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
